import { render } from "./LoginControl.vue?vue&type=template&id=2b572335&scoped=true"
import script from "./LoginControl.vue?vue&type=script&lang=js"
export * from "./LoginControl.vue?vue&type=script&lang=js"

import "./LoginControl.vue?vue&type=style&index=0&id=2b572335&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b572335"]])

export default __exports__